import { render, staticRenderFns } from "./authority-dialog.vue?vue&type=template&id=c9149c66&scoped=true"
import script from "./authority-dialog.vue?vue&type=script&lang=js"
export * from "./authority-dialog.vue?vue&type=script&lang=js"
import style0 from "./authority-dialog.vue?vue&type=style&index=0&id=c9149c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9149c66",
  null
  
)

export default component.exports